/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type WorkflowConstantFeature = {
  name: string
  /**
   * * `TEXT` - Text
   * * `NUMBER` - Number
   * * `BOOLEAN` - Boolean
   * * `DATE` - Date
   * * `LIST` - List
   * * `DICT` - dict
   */
  type?: WorkflowConstantFeature.type
  feature_nesting_separator?: string
  /**
   * Set to null as a default value to be computed on demand to avoid the huge migration
   */
  is_used?: boolean | null
  value: unknown
}
export namespace WorkflowConstantFeature {
  /**
   * * `TEXT` - Text
   * * `NUMBER` - Number
   * * `BOOLEAN` - Boolean
   * * `DATE` - Date
   * * `LIST` - List
   * * `DICT` - dict
   */
  export enum type {
    TEXT = "TEXT",
    NUMBER = "NUMBER",
    BOOLEAN = "BOOLEAN",
    DATE = "DATE",
    LIST = "LIST",
    // TODO: commented out as DICTS are unsupported
    // DICT = "DICT",
  }
}
